import { machines } from '../data/machines';
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../assets/styles/PwnedMachines.css';

const PwnedMachinesPage = () => {
  useEffect(() => {
    console.log('machines data:', machines);
    window.__machines = machines; // expose globally
  }, []);
  return (
    <div className="pwned-machines-page">
      <h2>Pwned Machines</h2>
      <div className="machines-grid">
        {machines.map((machine) => (
          <Link
            key={machine.id}
            to={`/pwnedmachines/${machine.id}`}
            className="machine-card"
          >
            <img src={machine.image} alt={`${machine.name} thumbnail`} />
            <div className="machine-info">
              <h3>{machine.name}</h3>
              <p>{machine.description}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default PwnedMachinesPage;